import React, { PureComponent } from 'react';
import styled from 'styled-components';

import ListPagination from './ListPagination';
import ListItem from './ListItem';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${props =>
    props.empty &&
    `
    justify-content: center;
    text-align: center;
  `};
`;
const ListItems = styled.ul`
  flex: 1;
`;

export default class List extends PureComponent {
  render() {
    const {
      className,
      shops,
      selectedShopId,
      currentPage,
      totalPages,
      onItemClick: handleListItemClick,
      onChangePage: handleListPaginationClick,
      t
    } = this.props;

    const isSelected = id => {
      if (!selectedShopId) return false;
      return selectedShopId.toString() === id.toString();
    };

    return (
      <Wrapper className={className} empty={!shops.length}>
        {shops.length ? (
          <ListItems>
            {shops.map(shop => (
              <ListItem
                key={`Shops_ListItem_${shop.id}`}
                shop={shop}
                onClick={handleListItemClick}
                isSelected={isSelected(shop.id)}
              />
            ))}
          </ListItems>
        ) : (
          t('blocks.shops.map.error.noResult')
        )}
        {totalPages > 0 && (
          <ListPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onChange={handleListPaginationClick}
          />
        )}
      </Wrapper>
    );
  }
}
